import React, { useEffect, useState } from 'react';
import { StyledCellLink } from '../Common/DataGrid/CellComponents';
import { getDateRangeFilterOperator } from '../Common/DataGrid/FilterComponents';
import { select_commonCellProps, text_commonCellProps } from '../Common/DataGrid/utils';
import {
    DataGrid
} from '../Common';
import Routes from '../../routes';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { fetchFilterValues } from '../../utils';

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const columns = [
    {
        field: 'region',
        headerName: 'Region',
        ...text_commonCellProps
    },
    {
        field: 'locationName',
        headerName: 'Location',
        ...select_commonCellProps,
        renderCell: ({ row: { locationName, locationId } }) => (
            <StyledCellLink
                path={`/Location/${locationId}`}
                text={locationName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'assetName',
        headerName: 'Asset Name',
        ...text_commonCellProps,
        renderCell: ({ row: { assetName, assetId } }) => (
            <StyledCellLink
                path={`/Inventory/${assetId}`}
                text={assetName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'assetType',
        headerName: 'Type',
        ...select_commonCellProps
    },
    {
        field: 'lastInspectionDateString',
        headerName: 'Last Inspection Date',
        filterOperators: dateRangeFilterOperator,
    },
]

const LeakDetector350Days = () => {
    const [filters, setFilters] = useState([]);

    const fetchFilters = async () => {
        const filters = await fetchFilterValues(Routes.Dashboard.LeakDetector350DaysDropdown());
        setFilters(filters);
    };

    useEffect(() => { fetchFilters() }, []);

    return (
        <DataGrid
            url={Routes.Dashboard.LeakDetector350Days(false)}
            exportButtonURL={Routes.Dashboard.LeakDetector350Days(true)}
            filterOptions={filters}
            columns={columns}
            rowCount="5"
            tableId={'leak-detector-350Days-table'}
            exportFileName={"ALDS WITHOUT CALIBRATION SERVICE FOR MORE THAN 350 DAYS table"}
            exportButtonAlt={"Export ALDS WITHOUT CALIBRATION SERVICE FOR MORE THAN 350 DAYS table (.csv)"}
            noResultText="Oops...It is empty here..."
            noResultText2="Create a new asset or change your search criteria."
            dataGridSx={{
                border: 'none'
            }}
        />
    )
}

export default LeakDetector350Days;
